export default "__VITE_ASSET__Bq2kKdkW__"